// Library Imports
import store, { RootState } from "store";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { Popover, Tooltip, Typography } from "antd";

// Local Imports
import Checkbox from "../../Common/Components/Checkbox";
import Speed from "../../../assets/img/icons/Speed.svg";
import { ReactComponent as Elipsis } from "../../../assets/img/icons/Elipsis.svg";
import Profile from "../../../assets/img/icons/ArticlePopover/lowerList/profile.svg";
import { ReactComponent as Mail } from "../../../assets/img/icons/mail.svg";
import { ReactComponent as Click } from "../../../assets/img/icons/Click.svg";
import { ReactComponent as Send } from "../../../assets/img/icons/SendingWhite.svg";
import { ReactComponent as Eye } from "../../../assets/img/icons/eye.svg";
import { IContactItem } from "../Audience/interface";
import { AUDIENCE_LISTS_DETAILS, DEFAULT_CAMPAIGN_IMAGE } from "../../../constants/types";
import { removeOnClickBubble } from "utils";
import {
  getContactDashboard,
  getContactDetails,
  getContactEngagement,
  getContactSimilar,
  getContactSubscriptions,
} from "../Audience/actions";
import { openDetailProfile, openOverlay } from "modules/GlobalActions";
import { CAMPAIGN_AUDIENCE, PEOPLE_AUDIENCE } from "constants/actionTypes";

const UserPopoverTitle = (
  <div className="padding-top-sm padding-bottom-sm padding-right-md">
    <h4 className="mb-0">Edit Contact</h4>
  </div>
);

const UserPopoverContent = (setShowEditContactPopover: any) => (
  <div className="BlogItemDropdown">
    <ul className="me-4">
      <li className="d-flex mb-1 cursor-pointer" onClick={() => editContactHandler(setShowEditContactPopover)}>
        <img src={Profile} alt="" /> &nbsp;&nbsp;Contact details
      </li>
    </ul>
  </div>
);

const editContactPopoupAction = (state: boolean) => {
  store.dispatch({
    type: CAMPAIGN_AUDIENCE.SET_EDIT_CONTACT_POPOVER_STATE,
    payload: { editContactPopup: state },
  });
};

const editContactHandler = (setShowEditContactPopover: (arg: boolean) => void) => {
  setShowEditContactPopover(false);
  store.dispatch({
    type: PEOPLE_AUDIENCE.RESET_EDIT_CONTACT,
  });
  store.dispatch({
    type: PEOPLE_AUDIENCE.OPEN_EDIT_CONTACT_SIDEBAR,
  });
  editContactPopoupAction(false);
  openOverlay();
};

interface IUserListItemProps {
  contact: IContactItem;
  hideIcons?: boolean;
  hideEllipsesMenu?: boolean;
  isChecked?: boolean;
  selectAll?: boolean;
  onClickChecked?: (value: any) => void;
  isProfiled?: boolean;
  deleteAllFlag?: boolean;
  contactCheckHandler?: (id: string, isChecked: boolean) => void;
  handleReselectItem?: (id: string) => void;
  status: string;
  index: number;
}

const UserListItem: React.FC<IUserListItemProps> = (props) => {
  // Local States
  const { contact, isChecked, hideIcons, onClickChecked, isProfiled, selectAll, index } = props;
  const { Paragraph } = Typography;
  const [showEditContactPopover, setShowEditContactPopover] = useState(false);
  const [deleteInProgressState, setdeleteInProgressState] = useState(false);
  const [ellipsisState, setEllipsistate] = useState(false);
  const [ellipsisStateDesignation, setEllipsistateDesignation] = useState(false);
  const [ellipsisStateEmail, setEllipsistateEmail] = useState(false);
  const [newlyAddedContact, setNewlyAddedContact] = useState(false);

  // Redux States
  const editContactPopup: boolean = useSelector((state: RootState) => state.audience.editContactPopup);
  const importListAsider: boolean = useSelector((state: RootState) => state.audience.importListAsider);
  const showDetailProfile: boolean = useSelector((state: RootState) => state.audience.showDetailProfile);
  const linkAsider: boolean = useSelector((state: RootState) => state.audience.linkAsider);
  const deleteInProgress: boolean = useSelector((state: RootState) => state.audienceListDetails.delete.loading);
  const contactAddedInList: boolean = useSelector(
    (state: RootState) => state.audienceListDetails.contactAddedInList
  );

  // Component Logic
  useEffect(() => {
    if (contactAddedInList) {
      setNewlyAddedContact(true);
      setTimeout(() => {
        setNewlyAddedContact(false);
      }, 4000);
      store.dispatch({
        type: AUDIENCE_LISTS_DETAILS.RESET_NEWLY_ADDED_CONTACT,
      });
    }
  }, [contactAddedInList]);

  const editContactPopoupAction = (state: boolean) => {
    store.dispatch({
      type: CAMPAIGN_AUDIENCE.SET_EDIT_CONTACT_POPOVER_STATE,
      payload: { editContactPopup: state },
    });
  };

  useEffect(() => {
    setdeleteInProgressState(deleteInProgress);
  }, [deleteInProgress]);

  useEffect(() => {
    if (isChecked) {
      setShowEditContactPopover(false);
      editContactPopoupAction(false);
    }
    if (showDetailProfile) {
      setShowEditContactPopover(false);
      editContactPopoupAction(false);
    }
    if (importListAsider) {
      setShowEditContactPopover(false);
      editContactPopoupAction(false);
    }
    if (linkAsider) {
      setShowEditContactPopover(false);
      editContactPopoupAction(false);
    }
  }, [isChecked, importListAsider, showDetailProfile, linkAsider]);

  const ellipsisHandler = () => {
    if (!editContactPopup && !showEditContactPopover) {
      editContactPopoupAction(true);
      setShowEditContactPopover(true);
      getContactDetails(contactId);
    } else {
      editContactPopoupAction(false);
      setShowEditContactPopover(false);
    }
  };

  const contactId = contact?.id?.toString();

  const UserContactListItemClickHandler = () => {
    openDetailProfile();
    getContactDetails(contactId);
    getContactDashboard(contactId);
    getContactSubscriptions(contactId);
    getContactEngagement(contactId);
    getContactSimilar(contactId);
  };

  useEffect(() => {
    if (!editContactPopup) setShowEditContactPopover(false);
  }, [editContactPopup]);

  const name = contact?.name?.trim() || contact?.email;

  /* Toggle class "active", "active-new" and "drag-active"  on tr for checked items */
  return (
    <tr
      onClick={UserContactListItemClickHandler}
      className={`table-style ${isChecked || selectAll ? "active-new" : "active qa-tr-active"} ${newlyAddedContact && index === 0 ? "active-new" : ""
        } ${deleteInProgressState ? "disabled" : ""} `}
      data-id="qa-list-table-tr"
    >
      <td className="checkbox">
        <Checkbox
          onClick={() => {
            if (props.deleteAllFlag && isChecked && props?.contactCheckHandler)
              props?.contactCheckHandler(contactId, isChecked);
            else if (props?.handleReselectItem && props.deleteAllFlag) props?.handleReselectItem(contactId);
          }}
          checked={isChecked || selectAll || false}
          onChange={onClickChecked}
          data-id="qa-checkbox-row"
        />
      </td>
      <td>
        <span
          className="profile-img-wrapper"
          style={{
            borderColor: contact?.color ? contact.color : "#ffffff",
            backgroundColor: contact?.color ? contact.color : "#ffffff",
          }}
        >
          <img src={contact?.thumbnail || DEFAULT_CAMPAIGN_IMAGE} className="profile-img" alt="" />
        </span>
        <div className="profile">
          <div className="hidden-contact-name">
            {contact?.name.trim() === "" || contact?.name === null || contact?.name === undefined
              ? contact?.email
              : contact?.name}
          </div>
          <Tooltip placement="top" title={ellipsisState ? name : undefined}>
            <Paragraph className="name" ellipsis={{ onEllipsis: setEllipsistate }}>
              {name}
            </Paragraph>
          </Tooltip>

          <Tooltip placement="top" title={ellipsisStateEmail ? contact?.email : undefined}>
            <Paragraph className="email" ellipsis={{ onEllipsis: setEllipsistateEmail }}>
              {contact?.email}
            </Paragraph>
          </Tooltip>

          <Tooltip placement="top" title={ellipsisStateDesignation ? contact?.designation : undefined}>
            <Paragraph className="email designation" ellipsis={{ onEllipsis: setEllipsistateDesignation }}>
              {contact?.designation && contact?.designation.length > 0 ? contact?.designation : ""}
            </Paragraph>
          </Tooltip>
        </div>
      </td>
      <td>
        <strong className="organization company" data-qa="qa-orgainization">
          {contact?.organization}
        </strong>
      </td>
      <td>
        <strong className="personality d-flex align-items-center" data-qa="qa-orgainization-one">
          <Circle color={contact?.color ? contact.color : "black"} />
          {contact?.personality ? contact?.personality : "N/A"}
        </strong>
      </td>
      <td>
        <strong
          className={`status d-flex align-items-center ${props?.status === "Subscribed"
            ? "status-style-sub"
            : props?.status === "Unsubscribed"
              ? "status-style-unsub"
              : "status-style-bounce"
            }`}
        >
          {props?.status}
        </strong>
      </td>
      {!window.location.pathname.includes("campaigns") && <td></td>}

      {hideIcons ? null : (
        <td className="actions-td d-flex justify-content-center align-items-center">
          <div className="actions">
            <ul>
              <li>
                <a>
                  <Send />
                  <span>{contact?.totalSent}</span>
                </a>
              </li>
              <li>
                <a>
                  <Mail />
                  <span>{contact?.totalDelivery}</span>
                </a>
              </li>
              <li>
                <a>
                  <Eye />
                  <span>{contact?.totalOpens}</span>
                </a>
              </li>
              <li>
                <a>
                  <Click />
                  <span>{contact?.totalClicks}</span>
                </a>
              </li>
            </ul>
          </div>
        </td>
      )}
      <td className="last-item">
        <div className="engagement">
          <img src={Speed} alt="" />
          &nbsp;
          {contact?.engagementScore ?? 0}
        </div>
      </td>
      <td onClick={removeOnClickBubble}>
        <Popover
          title={UserPopoverTitle}
          content={UserPopoverContent(setShowEditContactPopover)}
          overlayClassName="BlogPopover"
          placement="leftTop"
          trigger="click"
          visible={showEditContactPopover}
          getPopupContainer={() => document.querySelectorAll(".audience-content-inner")[0] as HTMLElement}
        >
          <EllipsisSpan className={`${isChecked ? "disable" : ""}`} onClick={ellipsisHandler}>
            <Elipsis />
          </EllipsisSpan>
        </Popover>
      </td>
    </tr>
  );
};

export default UserListItem;

const Circle = styled.div<{ color: string }>`
  width: 10px;
  height: 10px;
  background: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 3px;
`;

const EllipsisSpan = styled.span`
  padding: 3px;
  position: relative;
  z-index: 0;
  margin-right: 5px;
  cursor: pointer;
  &.disable {
    pointer-events: none;
    opacity: 0.5;
  }
`;
